import { ColorEnum } from '@/constants/color'
import Notification from '@/features/notifications/components/Notification'
import CreatedAt from '@/features/notifications/components/NotificationCenter/parts/ListItem/Component/parts/CreatedAt'
import Heading from '@/features/notifications/components/NotificationCenter/parts/ListItem/Component/parts/Heading'
import { ComponentType, FC, ReactNode } from 'react'
import { View } from 'react-native'
import { SvgProps } from 'react-native-svg'
import { createStyleSheet, useStyles } from 'react-native-unistyles'

interface ListItemProps {
    Icon: ComponentType<SvgProps>
    iconContainerColor: ColorEnum
    heading: string
    createdAt: number
    Title: ReactNode
    Description?: ReactNode
    read: boolean
    onPress: () => void
}

const ListItem: FC<ListItemProps> = ({
    Icon,
    iconContainerColor,
    heading,
    createdAt,
    Title,
    Description,
    read,
    onPress,
}) => {
    const { styles } = useStyles(stylesheet, { read })

    return (
        <Notification onPress={onPress} style={styles.container}>
            <View style={styles.innerContainer}>
                <Notification.IconContainer Icon={Icon} color={iconContainerColor} size={40} />
                <View style={{ flex: 1, marginLeft: 16 }}>
                    <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
                        <Heading>{heading}</Heading>
                        <CreatedAt createdAt={createdAt} />
                    </View>
                    <View style={{ gap: 4 }}>
                        {Title}
                        {Description}
                    </View>
                </View>
            </View>
        </Notification>
    )
}

const stylesheet = createStyleSheet({
    container: {
        paddingHorizontal: 16,
        width: '100%',
        variants: {
            read: {
                true: {
                    opacity: 0.5,
                },
            },
        },
    },
    innerContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        borderBottomColor: ColorEnum.GRAY_200,
        borderBottomWidth: 1,
        height: 71,
        width: '100%',
    },
})

export default ListItem
